import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getCities } from '../addressService'

export function useCities(query?: string) {
  return useQuery({
    queryKey: [QUERY_KEYS.PLACES_CITIES, query ?? ''],
    queryFn: () => getCities(query),
  })
}
